// package: common
// file: common/user_feature.proto

import * as common_user_feature_type from "../common/user_feature_type";

export const UserFeature = {
    encode(object) {
        const message = {};
        if (object.type != null) {
            if (object.type !== 0) {
                message.type = object.type;
            }
        }
        if (object.value != null) {
            if (object.value !== "") {
                message.value = String(object.value);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            type: 0,
            value: "",
        };

        if (message.type != null) {
            object.type = message.type;
        }
        if (message.value != null) {
            object.value = message.value;
        }
        return object;
    },
};


